import { render, staticRenderFns } from "./communicationLogForm.vue?vue&type=template&id=269bdc8c&%23default=true&"
import script from "./communicationLogForm.vue?vue&type=script&lang=js&"
export * from "./communicationLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports